import React, { useState } from 'react';
import { Building2 } from 'lucide-react';
import { Card, Button } from './ds';
import { companyService } from '../services';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";
const BRAND = 'var(--brand-600)';

const inputStyle = {
  width: '100%', padding: '10px 14px', boxSizing: 'border-box',
  border: '1px solid #D7DCE4', borderRadius: 8, fontSize: 14,
  fontFamily: FONT, outline: 'none', marginBottom: 12, color: '#101623',
};

// Firmenprofil anlegen. Wird sowohl im Dashboard (erstmaliges Einrichten) als auch
// auf der Pricing-Seite (Firma muss vor dem Checkout existieren — der Checkout ist
// company-first) verwendet. Ruft nach erfolgreichem Anlegen onCreated(company).
const CompanyOnboardingForm = ({
  onCreated,
  title = 'Unternehmen einrichten',
  subtitle = 'Erstellen Sie Ihr Unternehmensprofil, um IT-Assessments durchzuführen.',
  submitLabel = 'Weiter',
}) => {
  const [name, setName] = useState('');
  const [street, setStreet] = useState('');
  const [zip, setZip] = useState('');
  const [city, setCity] = useState('');
  const [ownerPosition, setOwnerPosition] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await companyService.createCompany({
        name, street, zipCode: zip, city, ownerPosition,
      });
      onCreated(res.data);
    } catch (err) {
      setError(err?.response?.data?.error || 'Unternehmen konnte nicht angelegt werden. Bitte versuchen Sie es erneut.');
      setSubmitting(false);
    }
  };

  return (
    <Card padding={0} style={{ maxWidth: 420, width: '100%', margin: '0 auto' }}>
      <div style={{ padding: '36px 40px' }}>
        <div style={{
          width: 44, height: 44, borderRadius: 10, background: '#F2F6FE', color: BRAND,
          display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18,
        }}>
          <Building2 width={22} height={22} />
        </div>
        <h2 style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 700, color: '#101623', fontFamily: FONT }}>{title}</h2>
        <p style={{ margin: '0 0 22px', color: '#667085', fontSize: 14, lineHeight: 1.6, fontFamily: FONT }}>
          {subtitle}
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text" placeholder="Unternehmensname"
            value={name} onChange={e => setName(e.target.value)}
            required autoFocus style={inputStyle}
          />
          <input
            type="text" placeholder="Straße und Hausnummer"
            value={street} onChange={e => setStreet(e.target.value)}
            required style={inputStyle}
          />
          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <input
              type="text" placeholder="PLZ"
              value={zip} onChange={e => setZip(e.target.value)}
              required style={{ ...inputStyle, width: '35%', marginBottom: 0 }}
            />
            <input
              type="text" placeholder="Ort"
              value={city} onChange={e => setCity(e.target.value)}
              required style={{ ...inputStyle, width: '65%', marginBottom: 0 }}
            />
          </div>
          <select
            value={ownerPosition} onChange={e => setOwnerPosition(e.target.value)}
            required
            style={{ ...inputStyle, color: ownerPosition ? '#101623' : '#8A93A3' }}
          >
            <option value="" disabled>Ihre Position im Unternehmen</option>
            <option value="Geschäftsführer">Geschäftsführer</option>
            <option value="IT-Verantwortlicher">IT-Verantwortlicher</option>
          </select>
          {error && (
            <p style={{ color: 'var(--crit-600, #C0342B)', fontSize: 13, margin: '0 0 12px' }}>{error}</p>
          )}
          <Button type="submit" fullWidth size="md" disabled={submitting}>
            {submitting ? 'Wird angelegt …' : submitLabel}
          </Button>
        </form>
      </div>
    </Card>
  );
};

export default CompanyOnboardingForm;
